import * as React from 'react';
import * as styles from './styles.scss';
import {
  Fallback,
} from 'components/common';

import { IState } from 'redux/global-reducers';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithNamespaces, withNamespaces } from 'react-i18next';

import { connect } from 'react-redux';

import { handleError } from 'utils/common';


import { withErrorBoundary } from 'react-error-boundary';
import { Lang } from 'constants/enum';


interface IDepositQrProps
  extends React.ClassAttributes<DepositQrComponent>,
  WithNamespaces,
  RouteComponentProps {
  readonly accountList: IState['accountList'];
  readonly selectedAccount: IState['selectedAccount'];
  readonly lang: Lang;
  readonly config: IState['config'];
}

interface IDepositQrState {

}

class DepositQrComponent extends React.Component<
  IDepositQrProps,
  IDepositQrState
> {


  constructor(props: IDepositQrProps) {
    super(props);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps: IDepositQrProps) {
  }

  componentWillUnmount() {
  }

  render() {
    const {
      t,
    } = this.props;

    let width = "936px";
    let height = "460px";

    let qrCodeStyle: React.CSSProperties = {
      margin:"150px auto",
    };

    if (document.body.clientWidth < 1015) {
      width = (document.body.clientWidth - 65) +"px";
      height = "800px";
      qrCodeStyle.margin= "auto";
    }

    const iframeStyle: React.CSSProperties = {
      border: '1px solid #323A50',
      borderRadius: '4px',
    };

    let selectedAccount = this.props.selectedAccount;
    if (selectedAccount && selectedAccount.accountNumber) {
          let accountNumber = selectedAccount.accountNumber;
          let accountList = this.props.accountList.filter((e)=> e.accountNumber !== accountNumber).map((e)=>{return e.accountNumber}).join(",");
          if (accountList) {
            accountList = accountNumber+","+accountList;
          }
          return (<div style={qrCodeStyle}>
                    <iframe
                      src={`${this.props.config.urlDepositQr}?accounts=${accountList?accountList:accountNumber}&name=${selectedAccount.accountName}&lang=${this.props.lang}`}
                      width={width}
                      height={height}
                      name="demo-deposit-frame"
                      frameBorder="0"  
                      style={iframeStyle}               
                  ></iframe>
                  <div className={styles.DepositTipsContent} dangerouslySetInnerHTML={{__html: t(`DepositQRTips`) }}></div>
                  </div>); 
    }
    return <></>
  }
}


const mapStateToProps = (state: IState) => ({
  accountList: state.accountList,
  selectedAccount: state.selectedAccount,
  lang: state.lang,
  config: state.config,  
});

const mapDispatchToProps = {
  
};

const DepositQr = withRouter(
  withErrorBoundary(
    withNamespaces('common')(
      connect(mapStateToProps, mapDispatchToProps)(DepositQrComponent)
    ),
    Fallback,
    handleError
  )
);

export default DepositQr;



// WEBPACK FOOTER //
// ./src/components/areas/Account/DepositQr/index.tsx